// extracted by mini-css-extract-plugin
export default {"fieldset":"rWg1vj"};